import { useEffect } from 'react';
import useCartStore from '../store/cartStore';
import useAuthStore from '../store/authStore';

/**
 * Custom hook to manage cart persistence across authentication states
 * This hook ensures cart contents are preserved when users:
 * - Browse as guests and then sign in
 * - Sign out and continue browsing
 * - Refresh the page or return to the site
 */
export const useCartPersistence = () => {
  const { isAuthenticated, isLoading: authLoading } = useAuthStore();
  const { loadPersistedCart, saveCartToStorage } = useCartStore();

  useEffect(() => {
    // Only load cart after auth check is complete
    if (!authLoading) {
      loadPersistedCart();
    }
  }, [authLoading, loadPersistedCart]);

  // Auto-save cart changes
  useEffect(() => {
    const handleBeforeUnload = () => {
      saveCartToStorage();
    };

    // Save cart before page unload
    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [saveCartToStorage]);

  return {
    isCartReady: !authLoading,
    isAuthenticated
  };
};
